// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","352":"fbaa5dc1","513":"8b3c010d","625":"e46524f4","706":"cc727622"}[chunkId] + ".chunk.js";
};